import { render, staticRenderFns } from "./DispatchPanel.vue?vue&type=template&id=3e1ff09a&scoped=true&"
import script from "./DispatchPanel.vue?vue&type=script&lang=js&"
export * from "./DispatchPanel.vue?vue&type=script&lang=js&"
import style0 from "./DispatchPanel.vue?vue&type=style&index=0&id=3e1ff09a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1ff09a",
  null
  
)

export default component.exports